/* 720 Express — tema etkileşimleri (Maximize düzeni, Dawn üstüne; altyapı Kuka katmanından uyarlandı 2026-10-08). Bağımlılık yok.
   Başlık: yapışkan/kompakt · mega sekmeler · mobil çekmece + alt paneller · arama kategorisi
   Bölümler: kaydırıcı (ok + ilerleme) · sekmeler · geri sayım · kod kopyalama · duyuru döndürme · hakkında aç/kapa
   Ticaret: hızlı ekle (Dawn cart-drawer'ı açar) · hızlı bakış modalı (/products/x?view=hizli) */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const on = (el, ev, fn, o) => el && el.addEventListener(ev, fn, o);

  /* ---------- toast ---------- */
  let toastT;
  function toast(msg, hata) {
    let t = $('.mx-toast');
    if (!t) { t = document.createElement('div'); t.className = 'mx-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.toggle('is-error', !!hata); t.classList.add('is-show');
    clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('is-show'), 2600);
  }

  /* ---------- başlık: yapışkan + kompakt ---------- */
  function initHeader() {
    const wrap = $('[data-mx-header-wrap]'), head = $('[data-mx-header]');
    if (!wrap || !head) return;
    let esik = 0;
    const olc = () => { wrap.style.minHeight = ''; wrap.style.minHeight = wrap.offsetHeight + 'px'; esik = wrap.getBoundingClientRect().top + window.scrollY + wrap.offsetHeight; };
    olc(); on(window, 'resize', olc);
    let son = false;
    const kontrol = () => {
      const yapis = window.scrollY > esik + 40;
      if (yapis !== son) { head.classList.toggle('is-sticky', yapis); document.documentElement.classList.toggle('mx-sticky', yapis); son = yapis; }
    };
    on(window, 'scroll', kontrol, { passive: true }); kontrol();
    document.documentElement.style.setProperty('--mx-header-h', head.offsetHeight + 'px');

    // mega sekmeler: sekmeye gelince paneli değiştir
    $$('[data-mx-mega-tabs]').forEach((m) => {
      const tabs = $$('[data-mx-tab]', m), panels = $$('[data-mx-panel]', m);
      tabs.forEach((t) => on(t, 'mouseenter', () => {
        tabs.forEach((x) => x.classList.toggle('is-active', x === t));
        panels.forEach((p) => p.classList.toggle('is-active', p.dataset.mxPanel === t.dataset.mxTab));
      }));
    });
    // klavye: odak menü içindeyken açık kalsın
    $$('.mx-nav__item').forEach((li) => {
      on(li, 'focusin', () => li.classList.add('is-open'));
      on(li, 'focusout', (e) => { if (!li.contains(e.relatedTarget)) li.classList.remove('is-open'); });
    });

    // arama kategorisi
    const f = $('[data-mx-search]');
    if (f) {
      const sel = $('[data-mx-search-cat]', f), lab = $('[data-mx-search-cat-label]', f);
      on(sel, 'change', () => { lab.textContent = sel.options[sel.selectedIndex].text; });
      on(f, 'submit', (e) => {
        const q = f.q.value.trim(), c = sel.value;
        if (c && !q) { e.preventDefault(); location.href = '/collections/' + c; return; }
        if (c) { e.preventDefault(); location.href = '/search?type=product&options[prefix]=last&q=' + encodeURIComponent(q + ' AND tag:"' + sel.options[sel.selectedIndex].text.trim() + '"'); }
      });
    }
  }

  /* ---------- çekmece ---------- */
  function initDrawer() {
    const d = $('[data-mx-drawer]');
    if (!d) return;
    const acBtn = $$('[data-mx-drawer-open]');
    const ac = () => { d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.body.classList.add('mx-lock'); acBtn.forEach((b) => b.setAttribute('aria-expanded', 'true')); };
    const kapa = () => { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.body.classList.remove('mx-lock'); acBtn.forEach((b) => b.setAttribute('aria-expanded', 'false')); $$('.mx-drawer__sub.is-open', d).forEach((s) => s.classList.remove('is-open')); };
    acBtn.forEach((b) => on(b, 'click', () => (d.classList.contains('is-open') ? kapa() : ac())));
    $$('[data-mx-drawer-close]', d).forEach((b) => on(b, 'click', kapa));
    on(document, 'keydown', (e) => { if (e.key === 'Escape') kapa(); });
    $$('[data-mx-sub-open]', d).forEach((b) => on(b, 'click', () => $(`[data-mx-sub="${b.dataset.mxSubOpen}"]`, d).classList.add('is-open')));
    $$('[data-mx-sub-close]', d).forEach((b) => on(b, 'click', () => b.closest('.mx-drawer__sub').classList.remove('is-open')));
  }

  /* ---------- kaydırıcı ---------- */
  function initSliders(root = document) {
    $$('[data-mx-slider]', root).forEach((s) => {
      if (s.dataset.mxReady) return; s.dataset.mxReady = 1;
      const tr = $('[data-mx-track]', s), prev = $('[data-mx-prev]', s), next = $('[data-mx-next]', s), bar = $('[data-mx-progress]', s);
      if (!tr) return;
      const adim = () => { const c = tr.children[0]; if (!c) return tr.clientWidth; const g = parseFloat(getComputedStyle(tr).columnGap) || 0; return c.getBoundingClientRect().width + g; };
      const guncel = () => {
        const max = tr.scrollWidth - tr.clientWidth;
        if (prev) prev.disabled = tr.scrollLeft <= 2;
        if (next) next.disabled = tr.scrollLeft >= max - 2;
        if (bar) { const oran = tr.clientWidth / tr.scrollWidth; bar.style.width = Math.max(oran, 0.08) * 100 + '%'; bar.style.transform = `translateX(${max > 0 ? (tr.scrollLeft / max) * ((1 - oran) / oran) * 100 : 0}%)`; }
        s.classList.toggle('is-static', max <= 2);
      };
      on(prev, 'click', () => tr.scrollBy({ left: -adim(), behavior: 'smooth' }));
      on(next, 'click', () => tr.scrollBy({ left: adim(), behavior: 'smooth' }));
      on(tr, 'scroll', guncel, { passive: true }); on(window, 'resize', guncel); guncel();
    });
  }

  /* ---------- sekmeler ---------- */
  function initTabs() {
    $$('[data-mx-tabs]').forEach((w) => {
      const btns = $$('[data-mx-tab-btn]', w), panels = $$('[data-mx-tab-panel]', w);
      btns.forEach((b) => on(b, 'click', () => {
        btns.forEach((x) => { x.classList.toggle('is-active', x === b); x.setAttribute('aria-selected', x === b); });
        panels.forEach((p) => p.classList.toggle('is-active', p.dataset.mxTabPanel === b.dataset.mxTabBtn));
      }));
    });
  }

  /* ---------- geri sayım ---------- */
  function initCountdown() {
    $$('[data-mx-countdown]').forEach((el) => {
      const ham = (el.dataset.mxCountdown || '').trim();
      const hedef = () => {
        if (ham) { const t = new Date(ham.replace(' ', 'T')); if (!isNaN(t)) return t; }
        const g = new Date(); g.setHours(23, 59, 59, 999); return g;
      };
      const p = (n) => String(Math.max(0, n)).padStart(2, '0');
      const tik = () => {
        let ms = hedef() - new Date(); if (ms < 0) ms = 0;
        const s = Math.floor(ms / 1000);
        $('[data-h]', el).textContent = p(Math.floor(s / 3600));
        $('[data-m]', el).textContent = p(Math.floor((s % 3600) / 60));
        $('[data-s]', el).textContent = p(s % 60);
      };
      tik(); setInterval(tik, 1000);
    });
  }

  /* ---------- küçükler ---------- */
  function initMisc() {
    $$('[data-mx-copy]').forEach((b) => on(b, 'click', async () => {
      try { await navigator.clipboard.writeText(b.dataset.mxCopy); toast('Kod kopyalandı: ' + b.dataset.mxCopy); } catch { toast('Kod: ' + b.dataset.mxCopy); }
    }));
    $$('[data-mx-rotate]').forEach((w) => {
      const m = $$('.mx-topbar__msg', w); if (m.length < 2) return; let i = 0;
      setInterval(() => { m[i].classList.remove('is-active'); i = (i + 1) % m.length; m[i].classList.add('is-active'); }, 4000);
    });
    $$('[data-mx-about]').forEach((a) => {
      const t = $('[data-mx-about-toggle]', a), metin = $('.mx-about__text', a);
      if (metin && metin.scrollHeight <= metin.clientHeight + 4) { t.hidden = true; return; }
      on(t, 'click', () => { const acik = a.classList.toggle('is-open'); t.textContent = acik ? 'Daha Az Göster' : 'Devamını Oku'; });
    });
  }

  /* ---------- kart görsel kaydırma (10-09) ---------- */
  // masaüstü: fare görselin hangi dilimindeyse o kare (≤4); çıkınca 1. kare. mobil (hover:none): yatay scroll-snap, gösterge scroll'dan.
  // 3-4. kareler data-mx-srcset ile bekler, ilk etkileşimde yüklenir. Delege ⇒ sayfalama ile değişen ızgaralarda da çalışır.
  const galYukle = (g) => {
    if (g.dataset.mxGalOk) return; g.dataset.mxGalOk = 1;
    $$('img[data-mx-srcset]', g).forEach((im) => { im.sizes = im.dataset.mxSizes || '50vw'; im.srcset = im.dataset.mxSrcset; im.removeAttribute('data-mx-srcset'); });
  };
  const galSec = (g, i) => {
    if (g._i === i) return; g._i = i;
    $$('.mx-gal__slide', g).forEach((s, k) => s.classList.toggle('is-active', k === i));
    $$('.mx-gal__dots i', g).forEach((d, k) => d.classList.toggle('is-active', k === i));
  };
  if (matchMedia('(hover: hover)').matches) {
    on(document, 'mousemove', (e) => {
      const g = e.target.closest && e.target.closest('[data-mx-gal]'); if (!g) return;
      galYukle(g);
      const n = $$('.mx-gal__slide', g).length, r = g.getBoundingClientRect();
      galSec(g, Math.min(n - 1, Math.max(0, Math.floor(((e.clientX - r.left) / r.width) * n))));
    }, { passive: true });
    on(document, 'mouseout', (e) => {
      const g = e.target.closest && e.target.closest('[data-mx-gal]');
      if (g && !g.contains(e.relatedTarget)) galSec(g, 0);
    });
  } else {
    on(document, 'touchstart', (e) => { const g = e.target.closest && e.target.closest('[data-mx-gal]'); if (g) galYukle(g); }, { passive: true });
    on(document, 'scroll', (e) => {
      const t = e.target; if (!t.classList || !t.classList.contains('mx-gal')) return;
      const g = t.closest('[data-mx-gal]'); galYukle(g);
      const i = Math.round(t.scrollLeft / t.clientWidth); g._i = null;
      $$('.mx-gal__dots i', g).forEach((d, k) => d.classList.toggle('is-active', k === i));
    }, { capture: true, passive: true });
  }

  /* ---------- sepet ---------- */
  // 10-09: sepete ekleme SESSİZ — çekmece açılmaz. Kart ikonu tıklandığı an tike döner, sayaç hemen artar (iyimser);
  // sunucu cevabıyla çekmece içeriği + sayaç arka planda tazelenir (açınca güncel). Hata olursa tik/sayaç geri alınır.
  const sayaclar = () => $$('#cart-icon-bubble .mx-cart__count');
  function sayacArttir(n) {
    sayaclar().forEach((c) => {
      c.textContent = (+c.textContent || 0) + n; c.classList.remove('is-empty');
      c.classList.remove('is-pop'); void c.offsetWidth; c.classList.add('is-pop');
    });
  }
  function sepetTazele(j) {
    const cd = document.querySelector('cart-drawer');
    const bolumler = cd && cd.getSectionsToRender ? cd.getSectionsToRender() : [{ id: 'cart-icon-bubble' }];
    bolumler.forEach((s) => {
      const el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
      const html = j.sections && j.sections[s.id];
      if (!el || !html) return;
      const d = new DOMParser().parseFromString(html, 'text/html').querySelector(s.selector || '.shopify-section');
      if (d) el.innerHTML = d.innerHTML;
    });
    if (cd) {
      cd.classList.remove('is-empty'); const ic = cd.querySelector('.drawer__inner'); ic && ic.classList.remove('is-empty');
      const ov = cd.querySelector('#CartDrawer-Overlay'); ov && cd.close && ov.addEventListener('click', cd.close.bind(cd));
    }
    sayaclar().forEach((c) => { c.classList.remove('is-pop'); void c.offsetWidth; c.classList.add('is-pop'); });
  }
  async function sepeteEkle(items, btn) {
    const cd = document.querySelector('cart-drawer');
    const sections = (cd && cd.getSectionsToRender ? cd.getSectionsToRender() : [{ id: 'cart-icon-bubble' }]).map((s) => s.id);
    const adet = items.reduce((a, x) => a + (x.quantity || 1), 0);
    sayacArttir(adet);
    try {
      const r = await fetch((window.routes?.cart_add_url || '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections, sections_url: location.pathname }),
      });
      const j = await r.json();
      if (!r.ok || j.status) { sayacArttir(-adet); toast(j.description || j.message || 'Ürün sepete eklenemedi.', true); return false; }
      sepetTazele(j);
      return true;
    } catch (e) { sayacArttir(-adet); toast('Bağlantı hatası, tekrar deneyin.', true); return false; }
  }

  on(document, 'click', async (e) => {
    const add = e.target.closest('[data-mx-add]');
    if (add) {
      e.preventDefault();
      if (add.classList.contains('is-added')) return;
      add.classList.add('is-added'); // anında tik
      const ok = await sepeteEkle([{ id: +add.dataset.mxAdd, quantity: 1 }], add);
      setTimeout(() => add.classList.remove('is-added'), ok ? 1600 : 0);
      return;
    }
    const qv = e.target.closest('[data-mx-quickview]');
    if (qv) { e.preventDefault(); hizliBakis(qv.dataset.mxQuickview, qv); }
  });

  // ürün sayfası formu: Dawn product-form yerine sessiz ekleme (capture: Dawn'ın dinleyicisinden önce) → buton "✓ Eklendi"
  on(document, 'submit', async (e) => {
    const f = e.target;
    if (!f.matches || !f.matches('product-form form[action*="/cart/add"]') || f.closest('.mx-modal')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    const btn = f.querySelector('[type=submit]'); if (!btn || btn.disabled || btn.classList.contains('is-added')) return;
    const fd = new FormData(f);
    const fid = f.getAttribute('id') || ''; // f.id = içerideki <input name="id"> (form alanı adı gölgeler), özniteliği oku
    const qtyEl = document.getElementById('Quantity-' + fid.replace('product-form-', '')) || document.querySelector(`input[name=quantity][form="${fid}"]`);
    const adet = Math.max(1, +(fd.get('quantity') || qtyEl?.value || 1));
    const span = btn.querySelector('span'); const eski = span ? span.textContent : '';
    btn.classList.add('is-added'); if (span) span.textContent = '✓ Eklendi';
    const ok = await sepeteEkle([{ id: +fd.get('id'), quantity: adet }], btn);
    setTimeout(() => { btn.classList.remove('is-added'); if (span) span.textContent = eski; }, ok ? 2200 : 0);
  }, true);

  /* ---------- hızlı bakış ---------- */
  function modal() {
    let m = $('.mx-modal');
    if (m) return m;
    m = document.createElement('div');
    m.className = 'mx-modal'; m.setAttribute('role', 'dialog'); m.setAttribute('aria-modal', 'true'); m.setAttribute('aria-label', 'Hızlı bakış');
    m.innerHTML = '<div class="mx-modal__overlay" data-mx-modal-close></div><div class="mx-modal__box"><button type="button" class="mx-modal__close mx-iconbtn" data-mx-modal-close aria-label="Kapat"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"><path d="m5 5 14 14M19 5 5 19"/></svg></button><div class="mx-modal__body"></div></div>';
    document.body.appendChild(m);
    $$('[data-mx-modal-close]', m).forEach((b) => on(b, 'click', () => kapatModal()));
    on(document, 'keydown', (e) => { if (e.key === 'Escape') kapatModal(); });
    return m;
  }
  function kapatModal() { const m = $('.mx-modal'); if (m) { m.classList.remove('is-open'); document.body.classList.remove('mx-lock'); } }

  async function hizliBakis(handle, btn) {
    const m = modal(), body = $('.mx-modal__body', m);
    btn && btn.classList.add('is-loading');
    try {
      const r = await fetch(`/products/${handle}?view=hizli`);
      if (!r.ok) throw new Error(r.status);
      body.innerHTML = await r.text();
    } catch { toast('Ürün açılamadı.', true); return; }
    finally { btn && btn.classList.remove('is-loading'); }
    m.classList.add('is-open'); document.body.classList.add('mx-lock');
    const qv = $('[data-mx-qv]', body);
    const variants = JSON.parse($('[data-mx-qv-variants]', body).textContent);
    const idInp = $('[data-mx-qv-id]', body), addBtn = $('[data-mx-qv-add]', body), priceEl = $('[data-mx-qv-price]', body);
    const goster = (i) => {
      $$('[data-mx-qv-img]', body).forEach((im) => im.classList.toggle('is-active', im.dataset.mxQvImg == i));
      $$('[data-mx-qv-thumb]', body).forEach((t) => t.classList.toggle('is-active', t.dataset.mxQvThumb == i));
    };
    $$('[data-mx-qv-thumb]', body).forEach((t) => on(t, 'click', () => goster(t.dataset.mxQvThumb)));
    const secim = () => $$('fieldset.mx-opt', body).map((fs, i) => { const c = $(`input[data-mx-opt="${i}"]:checked`, fs); return c ? c.value : null; });
    $$('[data-mx-opt]', body).forEach((inp) => on(inp, 'change', () => {
      const s = secim(); const v = variants.find((x) => x.options.every((o, i) => o === s[i]));
      $$('[data-mx-opt-label]', body).forEach((l, i) => (l.textContent = s[i]));
      if (!v) { addBtn.disabled = true; addBtn.firstElementChild.textContent = 'Mevcut değil'; return; }
      idInp.value = v.id; addBtn.disabled = !v.available; addBtn.firstElementChild.textContent = v.available ? 'Sepete Ekle' : 'Tükendi';
      priceEl.innerHTML = v.compare ? `<span class="mx-price mx-price--sale">${v.price}</span> <s class="mx-price mx-price--was">${v.compare}</s>` : `<span class="mx-price">${v.price}</span>`;
      if (v.media) goster(v.media - 1);
    }));
    $$('[data-mx-qty]', body).forEach((b) => on(b, 'click', () => { const i = $('input[name=quantity]', body); i.value = Math.max(1, (+i.value || 1) + +b.dataset.mxQty); }));
    on($('[data-mx-qv-form]', body), 'submit', async (e) => {
      e.preventDefault();
      const ok = await sepeteEkle([{ id: +idInp.value, quantity: +$('input[name=quantity]', body).value || 1 }], addBtn);
      if (ok) { kapatModal(); toast('✓ Ürün sepete eklendi'); }
    });
    qv && $('button, a', qv)?.focus({ preventScroll: true });
  }

  // 10-09 — ana sayfa ürün ızgarası sayfalama (1-2-3, Khakma gibi): [data-mx-sayfa] içindeki sayfa linkleri bölümü
  // yerinde değiştirir (Section Rendering API: ?page=N&sections=<id>), adres ?page=N olur, bölüm başına kayar. JS yoksa normal link.
  on(document, 'click', (e) => {
    const a = e.target.closest('[data-mx-sayfa] .pagination a[href]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    const kok = a.closest('[data-mx-sayfa]'); const id = kok.dataset.mxSayfa;
    const u = new URL(a.href, location.href); u.hash = '';
    const istek = new URL(u); istek.searchParams.set('sections', id);
    e.preventDefault();
    kok.classList.add('is-yukleniyor');
    fetch(istek, { credentials: 'same-origin' }).then((r) => r.json()).then((j) => {
      const yeni = new DOMParser().parseFromString(j[id] || '', 'text/html').querySelector('[data-mx-sayfa]');
      if (!yeni) { location.href = a.href; return; }
      kok.replaceWith(yeni);
      history.pushState({}, '', u.pathname + u.search);
      const hb = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--mx-header-h')) || 0;
      window.scrollTo({ top: yeni.getBoundingClientRect().top + window.scrollY - hb - 8, behavior: 'smooth' });
    }).catch(() => { location.href = a.href; });
  });
  on(window, 'popstate', () => { if ($('[data-mx-sayfa]')) location.reload(); });

  const basla = () => { initHeader(); initDrawer(); initSliders(); initTabs(); initCountdown(); initMisc(); };
  document.readyState === 'loading' ? on(document, 'DOMContentLoaded', basla) : basla();
  // tema editörü: bölüm yeniden yüklenince
  on(document, 'shopify:section:load', (e) => { initSliders(e.target); initTabs(); initCountdown(); initMisc(); });
})();
